<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Sofa2`]" width="1em" height="1em" v-bind="$attrs"><path d="M20.625 7.69149V6.28645C20.625 4.47419 19.1665 3 17.3738 3H6.62596C4.83326 3 3.37473 4.47419 3.37473 6.28645V7.69149C1.9976 8.14629 1 9.45691 1 10.999V18.1038C1 19.8491 2.36585 21.2785 4.07421 21.3565V21.9152C4.07421 22.5142 4.55475 23 5.14733 23C5.73991 23 6.22044 22.5142 6.22044 21.9152V21.36H17.7796V21.9152C17.7796 22.5142 18.2601 23 18.8527 23C19.4453 23 19.9258 22.5142 19.9258 21.9152V21.3565C21.6337 21.2785 23 19.8494 23 18.1038V10.999C23 9.45715 22.0022 8.14629 20.625 7.69149ZM6.62596 5.1699H17.374C17.9833 5.1699 18.479 5.67105 18.479 6.28645V7.69595C17.109 8.15497 16.1178 9.46211 16.1178 10.999V13.531H7.88246V10.999C7.88246 9.46211 6.89123 8.15497 5.52121 7.69595V6.28645C5.52097 5.67105 6.01671 5.1699 6.62596 5.1699ZM20.8535 18.1038C20.8535 18.7028 20.3715 19.1903 19.7787 19.1903H4.22082C3.62824 19.1903 3.14599 18.7031 3.14599 18.1038V10.999C3.14599 10.277 3.7268 9.69013 4.44074 9.69013C5.15468 9.69013 5.73549 10.277 5.73549 10.999V14.6161C5.73549 15.2151 6.21603 15.7009 6.80861 15.7009H17.1904C17.783 15.7009 18.2635 15.2151 18.2635 14.6161V10.999C18.2635 10.277 18.8443 9.69013 19.5583 9.69013C20.2722 9.69013 20.853 10.277 20.853 10.999L20.8535 18.1038Z"/></svg>
</template>
<script>

export default {
  name: 'IconSofa2',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
